import {DemoService} from 'app/core/services/demo.service';
import {AuthService} from 'app/core/services/auth.service';
import {ClientAnalyticsService} from 'app/core/services/client-analytics.service';
import {YandexMetricaService} from 'app/core/services/yandex-metrica.service';

export function ClientAnalyticsInitializerFactory(
    demo: DemoService,
    auth: AuthService,
    tagManager: ClientAnalyticsService,
    yandexMetrica: YandexMetricaService
) {
    return async () => {
        if (demo.isDemoHost) {
            return;
        }
        const user = await auth.init();
        yandexMetrica.init();
        if (!user) {
            return;
        }

        tagManager.sentEvents(user.googleConversionTrackingEvents);
        return;
    };
}
